const initialState = {
  utm_source: null,
  amountType: 'agencyFee',
  loaded: false,
  auth: { loaded: false, firebaseLoaded: false, signInLinkLoaded: false },
  airbnb: { strongerTogetherOpen: true },
  // TODO: move receips & form into airbnb object
  airbnbReceipts: [],
  referralCodeValid: true,
  noticeSettings: {
    hidden: true,
    blocking: false,
  },
}

export default initialState
